// src/pages/admin/billing/AdminBillingStockPage.js
import React from 'react';
import AdminLayout from '../../../components/admin/AdminLayout';
import PartForm from '../../../components/admin/billing/quote/PartForm';

function AdminBillingStockPage() {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  const handleSave = async (data) => {
    setLoading(true);
    try {
      // TODO: integrate with PocketBase parts collection
      console.log('Create/Update part', data);
      setOpen(false);
      return { id: String(Date.now()), ...data };
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title="">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <h1 style={{ marginTop: 0 }}>Stock</h1>
        <button
          className="btn-primary"
          onClick={() => setOpen(true)}
          style={{
            display: 'inline-flex', alignItems: 'center', gap: 10,
            padding: '10px 14px', borderRadius: 10,
            background: 'linear-gradient(135deg, var(--admin-accent), rgba(79,70,229,0.85))',
            border: '1px solid rgba(79,70,229,0.6)',
            boxShadow: '0 6px 18px rgba(79,70,229,0.35)',
            color: 'white'
          }}
        >
          <span style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:24, height:24, borderRadius:999, background:'rgba(255,255,255,0.18)', border:'1px solid rgba(255,255,255,0.25)' }}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </span>
          <span>Créer une pièce</span>
        </button>
      </div>
      <style>{`
        .btn-primary:hover { transform: translateY(-1px); filter: brightness(1.04); }
        .btn-primary:active { transform: translateY(0); filter: brightness(0.98); }
      `}</style>
      <p>Gestion des stocks (à connecter à PocketBase).</p>

      {open && (
        <PartForm
          onSave={handleSave}
          onCancel={() => setOpen(false)}
          loading={loading}
        />
      )}
    </AdminLayout>
  );
}

export default AdminBillingStockPage;
